module.exports = __webpack_public_path__ + "935c3bb0e80c8d4dbcb260d1019768ea.MP3";